import { Button, Dialog, Heading, Pane, Text } from 'evergreen-ui';
import { round } from 'lodash';
import moment from 'moment';
import { Component } from 'react';
import Request from '../../../util/Api';

class StockModal extends Component {

    constructor (props) {
        super(props);

        this.classes = props.classes;
        this.onClose = this.onClose.bind(this);
        this.fetchData = this.fetchData.bind(this);

        this.state = {
            stocks: [],
            sort: 'name_asc',
            showCancelled: false
        }
    }

    fetchData = async () => {
        const { apiEndpoint } = this.props;
        const results = await Request.get(apiEndpoint);

        this.setState({
            stocks: results.data
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if(prevProps.open === false && this.props.open === true) {
            this.fetchData();
        }
    }

    onClose = () => {
        this.setState({});
        this.props.onClose();
    }

    render () {
        let totalOutQty = 0;
        let totalInQty = 0;

        if (this.state.stocks.outputs) {
            this.state.stocks.outputs.forEach(output => {
                totalOutQty += (output.quantity || 0) *
                (output.status === 'cancelled' ? 0 : 1);
            });
        }

        if (this.state.stocks.inputs) {
            this.state.stocks.inputs.forEach(input => {
                totalInQty += (input.quantity || 0);
            });
        }

      return (<Dialog
        width={1400}
        isShown={this.props.open}
        title= {"Raport Stocuri"}
        hasFooter={false}
        onCloseComplete={this.onClose}
        onClose={this.onClose}>
            <Pane display="flex" justifyContent="center">
                <Pane minWidth={300} marginRight={20}>
                    <Heading flexGrow={1}>IN (Total: {totalInQty})</Heading>
                    <Pane>
                        {this.state.stocks.inputs ? this.state.stocks.inputs.map((input, index) => (
                            <Pane marginBottom={10} key={`stock-input-${input.id || index}`}>
                                <Pane>
                                    <Text><strong>Factura {input.documentName || '-'}/{input.documentDate ? moment(input.documentDate).format('DD.MM.YYYY') : '-'}</strong></Text>
                                </Pane>
                                <Pane>
                                    <Text>
                                        <a href={`/stock-operations/${input.id}`}>
                                            NIR {input.type || '-'}-{input.number || '-'}/{input.date ? moment(input.date).format('DD.MM.YYYY') : '-'}
                                        </a>
                                    </Text>
                                </Pane>
                                <Pane>
                                    <Text>Cantitate: <strong>{input.quantity || 0}</strong> la <strong>{input.value || 0}</strong> Lei/buc</Text>
                                </Pane>
                                {(input.quantity || 0) > 0 ?
                                    <Pane>
                                        <Text>Pret vanzare minim (cu TVA): <strong>{round((input.value || 0) * (100 + (this.props.vatBracket || 0)) / 100, 2)}</strong> Lei</Text>
                                    </Pane> : null}

                            </Pane>
                        )) : null}
                    </Pane>
                </Pane>
                <Pane  minWidth={300} marginRight={20}>
                    <Heading flexGrow={1}>OUT (Total: {totalOutQty} / {(this.state.stocks.outputs || []).length}) </Heading>
                    <Button marginBottom={10} onClick={() => {
                        this.setState({
                            sort: this.state.sort === 'name_asc' ? 'date_asc': 'name_asc'
                        })
                    }}>
                        Sortare {this.state.sort === 'name_asc' ? 'Dupa Data' : 'Dupa Nume'}
                    </Button>
                    <Button marginBottom={10} marginLeft={10} onClick={() => {
                        this.setState({
                            showCancelled: !this.state.showCancelled
                        })
                    }}>
                        {this.state.showCancelled ? 'Ascunde Anulate' : 'Arata Anulate'}
                    </Button>
                    <Pane>
                        {this.state.stocks.outputs ? this.state.stocks.outputs.sort((a, b) => {
                            return this.state.sort === 'date_asc' ? new Date(a.createdAt || 0) - new Date(b.createdAt || 0) :
                            (a.billingName || '').localeCompare(b.billingName || '');
                        }).filter(output => this.state.showCancelled || output.status !== 'cancelled').map((output, index) => (
                            <Pane marginBottom={10} key={`stock-output-${output.orderId || output.id || index}`}>
                                <Pane>
                                    <Text>
                                        <a href={`/orders/${output.orderId}`} target="_blank" rel="noreferrer">
                                            <strong>Comanda #{output.orderNumber || '-'}/{output.createdAt ? moment(output.createdAt).format('YYYY-MM-DD') : '-'} ({output.status || '-'})</strong>
                                        </a>
                                    </Text>
                                </Pane>
                                <Pane>
                                    <Text>{output.billingName || '-'}</Text>
                                </Pane>
                                <Pane>
                                    <Text>Cantitate: <strong>{output.quantity || 0}</strong> la <strong>{output.unitPrice || 0}</strong> Lei/buc</Text>
                                </Pane>
                            </Pane>
                        )) : null}
                    </Pane>
                </Pane>
                <Pane>
                    <Heading flexGrow={1}>Stock</Heading>
                    <Pane>
                        {this.state.stocks.stocks ? this.state.stocks.stocks.map((stock, index) => (
                            <Pane marginBottom={10} key={`stock-detail-${stock.id || index}`}>
                                <Pane>
                                    <Text>
                                        [{index}] - IN: {stock.entryType ? stock.entryType : '-'} / OUT: {stock.exitType ? `${stock.exitType} ( ${stock.exitObjectId} )` : '-'} / HOLD: {stock.lockedType ? `${stock.lockedType} ( ${stock.lockedObjectId} )` : '-'}
                                    </Text>
                                </Pane>
                            </Pane>
                        )) : null}
                    </Pane>
                </Pane>
            </Pane>



            <Button type="button" onClick={() => {
                this.props.onClose();
            }}>Inchide</Button>


      </Dialog>)
    }
}

export default StockModal;
